import {FC, ReactNode, useContext} from 'react';
import {useLocation} from 'react-router-dom';

import ROUTES from 'routes';
import AppRedirect from 'router/AppRedirect';
import {AuthContext} from "context/AuthContext";


interface PageProviderProps {
    children?: ReactNode;
}

const PageProvider: FC<PageProviderProps> = ({children}) => {
    const location = useLocation();
    const {isAuthorized, authLoaded} = useContext(AuthContext);

    const currentPath = location.pathname;
    const isLoginPage = currentPath === ROUTES.login.path;
    const isMainPage = currentPath === ROUTES.mainPage.path;
    const isRootOrLogin = isLoginPage || isMainPage;

    if (!authLoaded) return null;

    if (!isAuthorized && !isLoginPage) {
        return (
            <AppRedirect
                path="*"
                to={{
                    pathname: ROUTES.login.path,
                    state: {from: `${location.pathname}${location.search}`},
                }}
            />
        );
    }

    if (isAuthorized && isRootOrLogin) {
        return <AppRedirect path="*" to={{pathname: ROUTES.notificationViewer.path}}/>;
    }

    return <>{children}</>;
};

export default PageProvider;
